export default "__VITE_ASSET__DW13pcpd__"